import { render } from "./backendNotificationsDrawer.vue?vue&type=template&id=75ba4e78&ts=true"
import script from "./backendNotificationsDrawer.vue?vue&type=script&lang=ts"
export * from "./backendNotificationsDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__